import { gql } from '@apollo/client';

export const LIST_ASSET_COMPARISON_REPORTS = gql`
  query listAssetComparisonReports($args: ListAssetComparisonReportsInput!) {
    listAssetComparisonReports(args: $args) {
      totalCount
      __typename
      edges {
        cursor
        __typename
        node {
          __typename
          reportId
          createdBy
          createdAt
          completedAt
          riverJobId
          assetAInfo {
            assetId
            analysisId
            name
            assetType
            version
            vendor
            product
            orgId
            uploadedBy
            assetCreatedAt
            analysisCreatedAt
          }
          assetBInfo {
            assetId
            analysisId
            name
            assetType
            version
            vendor
            product
            orgId
            uploadedBy
            assetCreatedAt
            analysisCreatedAt
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
      }
    }
  }
`;

export const LIST_ASSET_COMPARISON_REPORTS_STATUSES = gql`
  query listAssetComparisonReportsStatuses($args: ListAssetComparisonReportsInput!) {
    listAssetComparisonReports(args: $args) {
      __typename
      edges {
        __typename
        node {
          __typename
          reportId
          completedAt
        }
      }
    }
  }
`;

export const GET_ASSET_COMPARISON_REPORT = gql`
  query getAssetComparisonReport($args: GetAssetComparisonReportInput!) {
    getAssetComparisonReport(args: $args) {
      reportId
      createdBy
      createdAt
      completedAt
      riverJobId
      assetAInfo {
        assetId
        analysisId
        name
        assetType
        version
        vendor
        product
        orgId
        uploadedBy
        assetCreatedAt
        analysisCreatedAt
      }
      assetBInfo {
        assetId
        analysisId
        name
        assetType
        version
        vendor
        product
        orgId
        uploadedBy
        assetCreatedAt
        analysisCreatedAt
      }
      comparisonReportSummary {
        assetAVulnerabilitySummary {
          totalCritical
          totalHigh
          totalMedium
          totalLow
          totalReachable
          totalKev
          totalWeaponized
          totalPoc
        }
        assetBVulnerabilitySummary {
          totalCritical
          totalHigh
          totalMedium
          totalLow
          totalReachable
          totalKev
          totalWeaponized
          totalPoc
        }
        assetAMisconfigurationsSummary {
          totalFailed
          totalPassed
        }
        assetBMisconfigurationsSummary {
          totalFailed
          totalPassed
        }
        assetACryptographySummary {
          totalFailed
          totalPassed
          totalNotApplicable
        }
        assetBCryptographySummary {
          totalFailed
          totalPassed
          totalNotApplicable
        }
        assetALicenseIssueSummary {
          totalCopyleft
          totalRelationalConflict
          totalLicenses
        }
        assetBLicenseIssueSummary {
          totalCopyleft
          totalRelationalConflict
          totalLicenses
        }
        assetACredentialsSummary {
          totalCrackedAccounts
          totalCrackedHashes
          totalExposedSecrets
        }
        assetBCredentialsSummary {
          totalCrackedAccounts
          totalCrackedHashes
          totalExposedSecrets
        }
        inventoryComparisonSummary {
          componentsInANotInB
          componentsInBNotInA
          totalOverlappingComponents
          licensesInANotInB
          licensesInBNotInA
          totalOverlappingLicenses
          binariesInANotInB
          binariesInBNotInA
          totalOverlappingBinaries
          filesInANotInB
          filesInBNotInA
          totalOverlappingFiles
        }
      }
      vulnerabilityDiff {
        inBNotInA {
          cveId
          componentName
          componentVersion
          severity
          cvssScore
          exploitMaturity
          reachable
          cisaKev
        }
        inANotInB {
          cveId
          componentName
          componentVersion
          severity
          cvssScore
          exploitMaturity
          reachable
          cisaKev
        }
        overlap {
          cveId
          componentName
          componentVersion
          severity
          cvssScore
          exploitMaturity
          reachable
          cisaKev
        }
        inBNotInAReachableCount
        inBNotInAKevCount
        inANotInBReachableCount
        inANotInBKevCount
        overlapReachableCount
        overlapKevCount
      }
      componentDiff {
        inBNotInA {
          name
          version
          type
          packageType
          licenses
          lowSevs
          mediumSevs
          highSevs
          criticalSevs
          totalVulns
          reachable
        }
        inANotInB {
          name
          version
          type
          packageType
          licenses
          lowSevs
          mediumSevs
          highSevs
          criticalSevs
          totalVulns
          reachable
        }
        overlap {
          name
          version
          type
          packageType
          licenses
          lowSevs
          mediumSevs
          highSevs
          criticalSevs
          totalVulns
          reachable
        }
        inBNotInAReachableCount
        inANotInBReachableCount
        overlapReachableCount
        assetATypeCounts {
          type
          count
        }
        assetBTypeCounts {
          type
          count
        }
      }
    }
  }
`;

export const CREATE_ASSET_COMPARISON_REPORT = gql`
  mutation createAssetComparisonReport($args: CreateAssetComparisonReportInput!) {
    createAssetComparisonReport(args: $args) {
      jobId
    }
  }
`;

export const DELETE_ASSET_COMPARISON_REPORT = gql`
  mutation deleteAssetComparisonReport($args: DeleteAssetComparisonReportInput!) {
    deleteAssetComparisonReport(args: $args)
  }
`;
